/**
 * @generated SignedSource<<0d5a2283605cc0ad54031dcaa84c81aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type subsectionViewRendererFragment$data = {
  readonly __id: string;
  readonly config: {
    readonly span: number | null | undefined;
  } | null | undefined;
  readonly elements: ReadonlyArray<{
    readonly __id: string;
    readonly " $fragmentSpreads": FragmentRefs<"customPageElementViewRendererFragment" | "elementErrorBoundaryFragment" | "homePageElementViewRendererFragment">;
  } | null | undefined> | null | undefined;
  readonly visualConfig?: {
    readonly " $fragmentSpreads": FragmentRefs<"alignmentSettingsContextFragment" | "alignmentSettingsContextHookFragment">;
  } | null | undefined;
  readonly " $fragmentType": "subsectionViewRendererFragment";
};
export type subsectionViewRendererFragment$key = {
  readonly " $data"?: subsectionViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"subsectionViewRendererFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "subsectionViewRendererFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutSubsectionConfig",
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "span"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "elements",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "homePageElementViewRendererFragment"
        },
        {
          "kind": "FragmentSpread",
          "name": "customPageElementViewRendererFragment"
        },
        {
          "kind": "FragmentSpread",
          "name": "elementErrorBoundaryFragment"
        },
        (v0/*: any*/)
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "HelpLayoutVisualConfig",
          "kind": "LinkedField",
          "name": "visualConfig",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "alignmentSettingsContextFragment"
            },
            {
              "kind": "FragmentSpread",
              "name": "alignmentSettingsContextHookFragment"
            }
          ]
        }
      ],
      "type": "HelpLayoutVisualEntity",
      "abstractKey": "__isHelpLayoutVisualEntity"
    },
    (v0/*: any*/)
  ],
  "type": "HelpLayoutSubsection"
};
})();

(node as any).hash = "92b814fe8e4ce783d39301c2a771dfb8";

export default node;
